'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VCenter = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var styles = {

  outer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: "auto"
  },

  table: {
    height: "100%",
    width: "100%",
    border: 0,
    padding: 0,
    margin: 0
  },

  cell: {
    verticalAlign: "middle",
    overflow: "auto",
    border: 0,
    padding: 0,
    margin: 0
  },

  box: {
    display: "inline-block"
  }

};

var VCenter = _react2['default'].createClass({

  displayName: "VCenter",

  mixins: [_reactAddonsPureRenderMixin2['default']],

  render: function render() {
    var children = this.props.children;


    return _react2['default'].createElement(
      'div',
      { style: styles.outer },
      _react2['default'].createElement(
        'table',
        { style: styles.table },
        _react2['default'].createElement(
          'tbody',
          null,
          _react2['default'].createElement(
            'tr',
            null,
            _react2['default'].createElement(
              'td',
              { style: styles.cell },
              _react2['default'].createElement(
                'div',
                { style: styles.box },
                children
              )
            )
          )
        )
      )
    );
  }
});

exports.VCenter = VCenter;


//////////////////
// WEBPACK FOOTER
// ./program/frontend/components/vcenter/index.jsx
// module id = 974
// module chunks = 0